import get from 'lodash/get';

import queryGenerateLtiSignature from './query';
import PluginService from '../PluginService';

const LTIForm = Object.freeze({
  defaultTarget: '_blank',
  method: 'post',
});

export default class LTIService {
  constructor({ id }) {
    this.id = id;
    this.pluginId = null;
  }

  async _generateLtiSignature(url, key, params) {
    if (!this.pluginId) {
      const plugin = PluginService.build({ id: this.id });
      const { id } = await plugin.getPlugin();
      this.pluginId = id;
    }

    const userId = window.piSession && window.piSession.userId();
    const paramsWithUserId = { ...params, user_id: userId }; // eslint-disable-line camelcase

    const ltiSignature = await queryGenerateLtiSignature({
      url,
      key,
      params: paramsWithUserId,
      pluginId: this.pluginId,
    });

    return ltiSignature;
  }

  _launchLTI(signLaunch, target = LTIForm.defaultTarget) {
    const { url, formParameters = {} } = signLaunch;
    const form = document.createElement('form');

    form.setAttribute('method', LTIForm.method);
    form.setAttribute('action', url);
    form.setAttribute('target', target);

    Object.entries(formParameters).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  async launch({ url, key, params, mode: target }) {
    const response = await this._generateLtiSignature(url, key, params);
    const signLaunch = get(response, 'data.pluginById.lti.toolProvider.signLaunch');
    if (signLaunch) {
      this._launchLTI(signLaunch, target);
    }
    return null;
  }

  async embed({ url, key, params }) {
    const response = await this._generateLtiSignature(url, key, params);
    const signLaunch = get(response, 'data.pluginById.lti.toolProvider.signLaunch');
    return signLaunch || null;
  }

  static build(args) {
    return new LTIService(args);
  }
}
